import Image from 'next/legacy/image';

import Icon from '@components/atoms/icon';

const ImagePanel = ({
  id,
  title,
  text,
  twitterUrl,
  imageUrl,
  buttonUrl,
  buttonText,
  height,
  width
}) => (
  <div key={id} className="flex p-4 lg:rounded-lg lg:shadow">
    <div className="relative flex-none w-24 mt-4 h-28">
      <Image
        src={imageUrl}
        height={height}
        width={width}
        alt="contributor-image"
        // WP Engine 403s Vercel's optimiser on cache-miss (FFH-1688)
        unoptimized
        className="absolute inset-0 w-full h-full rounded object-fit "
      />
    </div>
    <div className="flex-auto px-6 py-4">
      <div className="block">
        <h4 className="flex-auto text-lg font-semibold">
          {title}
          {twitterUrl && (
            <a
              className="ml-4 link"
              target="_blank"
              rel="noreferrer"
              href={twitterUrl}
            >
              <Icon name={'Twitter'} style={{ fontSize: 20 }} />
            </a>
          )}
        </h4>
        <div className="mt-1">
          <a className="font-medium link" href={buttonUrl}>
            {buttonText}
          </a>
        </div>

        <div className="flex-none w-full mt-2 font-medium leading-relaxed text-gray-500 break-words text-md ">
          {text}
        </div>
      </div>
    </div>
  </div>
);

export default ImagePanel;
